import { editorUGCTokens, editorUGCTokensModernized, editorUGCTokensRefreshed } from './editor-ugc-token-names';
function editorUGCToken(path, typographyTheme) {
  var token;
  switch (typographyTheme) {
    case 'typography-modernized':
      token = editorUGCTokensModernized[path];
      break;
    case 'typography-refreshed':
      token = editorUGCTokensRefreshed[path];
      break;
    default:
      token = editorUGCTokens[path];
      break;
  }
  return token;
}
export default editorUGCToken;